import React, { useState, useEffect } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './ColumnSelectorDialog.scss';
import { ROOFTOP_LINE } from '../Utilities/constants';
import { getCurrentLine } from '../services/CurrentLineService';

const ColumnSelectorDialog = ({
	visible,
	onClose,
	onSave,
	initialColumns,
	selectedColumns,
	onReset,
}) => {
	const [checkboxState, setCheckboxState] = useState();

	const handleCheckboxChange = (field) => {
		setCheckboxState((prevState) => ({
			...prevState,
			[field]: !prevState[field],
		}));
	};

	const handleSave = () => {
		onSave(checkboxState);
	};

	const loadlistColumns = (columns) => {
		setCheckboxState((prevState) => ({
			...prevState,
			...columns.reduce((acc, column) => {
				acc[column.field] = column.visible;
				return acc;
			}, {}),
		}));
	};

	useEffect(() => {
		if (selectedColumns) loadlistColumns(selectedColumns);
	}, [selectedColumns]);

	const resetColumns = () => {
		loadlistColumns(initialColumns);
		onReset();
	};

	const handleCancel = () => {
		loadlistColumns(initialColumns);
		onClose();
	};

	return (
		visible && (
			<Dialog width={'385px'} onClose={onClose} visible={visible}>
				<div className="roboto-19-700 mb-3 mt-2">
					{'Table column configuration'}
				</div>
				<button
					className="roboto-15-500 secondary-button blue-text mb-2"
					onClick={resetColumns}
					style={{ border: 'none', alignItems: 'center' }}
				>
					{'Reset to Predefined'}
					<span class="material-symbols-outlined">restart_alt</span>
				</button>
				<div
					className="roboto-15-500"
					style={{
						marginBottom: '16px',
						display: 'flex',
						justifyContent: 'space-between',
						flexDirection: 'row',
					}}
				>
					<div>Column</div>
					<div style={{ marginRight: '16px' }}>View</div>
				</div>
				<div
					style={{
						overflowY: 'scroll',
						maxHeight: window.innerHeight - 250,
						paddingRight: '8px',
					}}
				>
					{selectedColumns &&
						selectedColumns
							.filter(
								(column) =>
									column.field !== 'phase' &&
									!(
										column.field === 'etoproc' &&
										getCurrentLine().ProdFamilyName !== ROOFTOP_LINE
									)
							)
							.map((column) => (
								<div
									className="roboto-15-400"
									key={column.field}
									style={{
										marginBottom: '16px',
										display: 'flex',
										justifyContent: 'space-between',
										flexDirection: 'row',
										alignContent: 'baseline',
									}}
								>
									<div>{column.title}</div>
									<label className="custom-checkbox">
										<input
											type="checkbox"
											checked={checkboxState[column.field]}
											onChange={() => handleCheckboxChange(column.field)}
											style={{ display: 'none' }}
										/>
										<div
											className={`checkbox-icon ${checkboxState[column.field] ? 'checked' : ''}`}
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												height="24"
												viewBox="0 -960 960 960"
												width="24"
												fill="white"
											>
												<path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
											</svg>
										</div>
									</label>
								</div>
							))}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-end',
						gap: '8px',
						marginTop: '16px',
					}}
				>
					<button
						className="secondary-button roboto-15-500 blue-text"
						onClick={handleCancel}
					>
						Cancel
					</button>
					<button className="primary-button roboto-15-500" onClick={handleSave}>
						Save
					</button>
				</div>
			</Dialog>
		)
	);
};

export default ColumnSelectorDialog;
